module.exports = __webpack_public_path__ + "img/咨询服务.5cc14ef6.jpg";